<template>
  <div class="pt-4">
    <h2 class="text-body-1 black--text mb-2">
      Allekirjoitus
    </h2>
    <v-alert
      v-if="(signer.ssn && isSigned(signer.ssn)) || signed"
      color="green darken-1"
      dense
      text
      icon="check"
      border="left"
      prominent
    >
      <v-row align="center">
        <v-col :class="$vuetify.breakpoint.xs ? 'pb-0' : ''" class="grow">
          <b>{{ signer.name }}</b><br>
          {{ signer.ssn }}
        </v-col>
        <v-col :class="$vuetify.breakpoint.xs ? 'pt-0' : ''" class="shrink">
          Allekirjoitettu
        </v-col>
      </v-row>
    </v-alert>

    <v-alert
      v-else
      color="primary"
      text
      dense
      icon="lock"
      border="left"
      prominent
    >
      <v-row align="center">
        <v-col class="grow">
          <b>{{ signer.name }}</b><br>
          {{ signer.email }}
        </v-col>
        <v-col :class="$vuetify.breakpoint.xs ? 'pt-1' : ''" class="shrink">
          <v-btn color="primary" :href="netsLink(indexInSigners, responseIndex)">
            Allekirjoita
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';

export default {
  name: 'NetsSignature',
  props: {
    signed: {
      type: Boolean,
      default: false,
    },
    createDate: {
      type: String,
      default: '',
    },
    companyId: {
      type: String,
      default: '',
    },
    form: {
      type: Object,
      default: () => {},
    },
    signatures: {
      type: Array,
      default: () => [],
    },
    responseIndex: {
      type: Number,
      default: 0,
    },
    signers: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({}),
  computed: {
    ...mapState({
      currentSigner: state => state.currentSigner,
    }),
    signer() {
      // return this.signers
      //   .find(s => (s.email === this.currentSigner.email));
      return this.currentSigner.participantIndex
        ? this.signers[this.currentSigner.participantIndex] : null;
    },
    indexInSigners() {
      return this.signers.indexOf(this.signer);
    },
    signatureMakers() {
      if (this.responseIndex !== 0 && (this.responseIndex === 1 || this.responseIndex % 2 !== 0)) {
        return this.signers;
      }
      return this.form.offerers;
    },
  },
  methods: {
    isSigned(ssn) {
      return this.signatures.some(s => s.ssn === ssn);
    },
    getSignedName(item) {
      if (this.signatures.length > 0 && this.signatures.find(s => s.ssn === item.ssn)) {
        return this.signatures.find(s => s.ssn === item.ssn).name;
      }
      return item.name;
    },
    netsLink(index, responseIndex) {
      const baseUrl = process.env.VUE_APP_NETS;
      const state = `state=${this.$route.params.id}_${this.$route.params.offerId}_${index}_${responseIndex}_${this.$route.params.companyId}_${this.companyId}`;
      const clientId = `client_id=${process.env.VUE_APP_NETS_CLIENT}`;
      let redirectUrl = `redirect_uri=${process.env.VUE_APP_NETS_REDIRECT}`;
      if (this.companyId === '1' && process.env.NODE_ENV === 'production') {
        redirectUrl = 'redirect_uri=https%3A%2F%2Fhelmi.raumalkv.fi%2Fpublic%2Fapp%2Fnets';
      }
      const nonce = `nonce=${moment(this.createDate, 'YYYY-MM-DD HH:mm:ss')
        .format('DD.MM.YYYY-HH.mm')}`;
      const params = 'response_type=code&scope=openid+ssn+profile';
      const url = `${baseUrl}?${clientId}&${params}&${redirectUrl}&${state}&${nonce}`;
      return url;
    },
  },
};
</script>
